const InfoCircle = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={18} height={18} {...props} fill={props.color || "#dc2664"}>
        <path d="M9 0a9 9 0 109 9 9 9 0 00-9-9zm0 3.992a1.524 1.524 0 11-1.525 1.524A1.524 1.524 0 019 3.991zm2.032 9.218a.436.436 0 01-.435.435H7.403a.436.436 0 01-.435-.435v-.873a.436.436 0 01.435-.435h.434V9.58h-.434a.436.436 0 01-.435-.435v-.871a.436.436 0 01.435-.437h2.323a.436.436 0 01.435.435v3.629h.435a.436.436 0 01.435.435z" />
    </svg>
);

export default InfoCircle;
